import apiClient from '../Api';
import siteDesignApi from './site_design_api.js';
import {
  buildEntityDisplayUpdatePayload,
  buildStringRenamePayload
} from '../../features/panel-planning/utils/panelEntityNumbering.js';

export { buildStringRenamePayload };

/**
 * String 관련 API
 * - 삭제: SiteDesign DELETE /api/site-design/{siteId}/solar-string/{solarStringSeq} (하위 Module 포함)
 * - 이름 변경: Spring Data REST PATCH /api/solarStrings/{solarStringSeq}
 * - 이동: Spring Data REST PUT /api/solarStrings/{solarStringSeq}/solarArray
 */

/**
 * String + 하위 Module 삭제 (entity PK 사용)
 * @param {string|number} siteId
 * @param {string|number} solarStringSeq - JSON `id` / DB seq (표시용 stringId 아님)
 */
export const deleteSolarString = (siteId, solarStringSeq) =>
  siteDesignApi.deleteSolarString(siteId, solarStringSeq);

/**
 * String 이름/표시 ID 변경 (Spring Data REST — entity PK 사용)
 *
 * curl 예:
 * PATCH /api/solarStrings/429
 * Authorization: Bearer <JWT>
 * Content-Type: application/json
 * { "stringId": "41" }
 *
 * @param {string|number} solarStringSeq - JSON `id` / DB seq (표시용 stringId 아님)
 * @param {string} newName - 트리에 보이는 새 이름
 * @param {{displayId?: string|number}} [options] - 이동 후 명시적 표시 번호
 */
export const updateName = async (solarStringSeq, newName, options = {}) => {
  if (solarStringSeq == null || solarStringSeq === '') {
    throw new Error('solarStringSeq is required for string rename');
  }

  const payload =
    options.displayId != null
      ? buildEntityDisplayUpdatePayload('string', {
          name: newName,
          displayId: options.displayId
        })
      : buildStringRenamePayload(newName);
  if (!payload.stringId && !payload.name) {
    throw new Error('newName is required for string rename');
  }

  try {
    console.log(`🔄 String seq=${solarStringSeq} 이름 업데이트:`, payload);
    const response = await apiClient.update(`/solarStrings/${solarStringSeq}`, payload);
    return response.data;
  } catch (error) {
    console.error('String 이름 업데이트 실패:', error);
    throw error;
  }
};

// String을 다른 Array로 이동 (Spring Data REST association: PUT /solarStrings/{id}/solarArray)
export const moveToArray = async (solarStringSeq, targetArraySeq) => {
  try {
    console.log(`🔄 String ${solarStringSeq} → Array ${targetArraySeq}로 이동`);
    const { authHeader } = await import('../../_helpers');
    const axios = (await import('axios')).default;
    const _apiUrl = (process.env.VUE_APP_DOMAIN || '') + process.env.VUE_APP_API_URL;
    const response = await axios({
      method: 'put',
      url: `${_apiUrl}/solarStrings/${solarStringSeq}/solarArray`,
      headers: {
        Authorization: authHeader(),
        'Content-Type': 'text/uri-list'
      },
      data: `/api/solarArrays/${targetArraySeq}`
    });
    return response.data;
  } catch (error) {
    console.error('String 이동 실패:', error);
    throw error;
  }
};

export const stringApi = {
  deleteSolarString,
  buildStringRenamePayload,
  updateName,
  moveToArray
};
